import { Grid } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { TextField, Select } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { selectData } from './earning-mechanism-award-points-per.constants';

export const EarningMechanismAwardPointsPer = () => (
  <>
    <Typography variant='subtitle1' paragraph>
      Give members
    </Typography>
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          name='awardPointsPer.points'
          label='Number of Points'
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>
      <Grid item sm={3}>
        <Select
          name='awardPointsPer.rounding'
          label='Rounded'
          data={selectData}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
    </Grid>
  </>
);
